import { render, staticRenderFns } from "./FlightsItem.vue?vue&type=template&id=cff17a78&"
import script from "./FlightsItem.vue?vue&type=script&lang=js&"
export * from "./FlightsItem.vue?vue&type=script&lang=js&"
import style0 from "./FlightsItem.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports